import React from 'react';
import styled from 'astroturf/react';

import { Body } from 'js/design_system/Body';
import { BodyLink } from 'js/design_system/link/BodyLink';

export type OffsiteAuthor = {
  displayName: string;
  initials: string;
  url: string;
  affiliations?: string[];
};

const Card = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  gap: var(--spacing-xs-8, 8px);
`;

const Avatar = styled(Body).attrs({ size: 'md' })`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: var(--spacing-md-48, 48px);
  height: var(--spacing-md-48, 48px);
  border-radius: var(--border-radius-radius-round, 104px);
  background: var(--background-light-blue, #eef2f9);
  color: var(--text-link, #0645b1);
`;

const Metadata = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
`;

const Affiliation = styled(Body).attrs({ size: 'sm' })`
  color: var(--text-secondary, #535366);
`;

const OffsiteAuthorCard: React.FC<{ author: OffsiteAuthor }> = ({ author }) => (
  <Card>
    <Avatar aria-hidden="true">{author.initials}</Avatar>
    <Metadata>
      <BodyLink size="md" href={author.url}>
        {author.displayName}
      </BodyLink>
      {!!author.affiliations?.length && (
        <Affiliation>{author.affiliations.join(', ')}</Affiliation>
      )}
    </Metadata>
  </Card>
);

export default OffsiteAuthorCard;
